import { ApiService } from '../../services/api_service';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { ContextService } from '../../services/context_service';
import { DateneingabeBetrieblicheDatenBwlDaten } from './DateneingabeBetrieblicheDatenBwlDaten';
import { DateneingabeBetrieblicheDatenKennzahlen } from './DateneingabeBetrieblicheDatenKennzahlen';
import { DateneingabeBetrieblicheDatenKonfiguration } from './DateneingabeBetrieblicheDatenKonfiguration';
import { DateneingabeBetrieblicheDatenMotivation } from './DateneingabeBetrieblicheDatenMotivation';
import { DateneingabeBetrieblicheDatenSonstigeDaten } from './DateneingabeBetrieblicheDatenSonstigeDaten';
import { DateneingabeBetrieblicheDatenStandortGebaeude } from './DateneingabeBetrieblicheDatenStandortGebaeude';
import { DateneingabeBetrieblicheDatenUnternehmensdaten } from './DateneingabeBetrieblicheDatenUnternehmensdaten';
import { DateneingabeBetrieblicheDatenVeranstaltungen } from './DateneingabeBetrieblicheDatenVeranstaltungen';
import { DateneingabeBetrieblicheDatenZustaendigkeiten } from './DateneingabeBetrieblicheDatenZustaendigkeiten';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { getGewerk } from '../../main/functions/getGewerk';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';

interface DateneingabeBetrieblicheDatenProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortSelected: any;
    gefuehrterModus: boolean;
}

interface DateneingabeBetrieblicheDatenState {
    tabIndex: number;
    hideTabs: boolean;
}

export class DateneingabeBetrieblicheDaten extends React.Component<DateneingabeBetrieblicheDatenProps, DateneingabeBetrieblicheDatenState> {

    constructor(props: any) {
        super(props);
        const isCfm: boolean = (props.data || {}).MODUL_SELECTED === 'cfm';
        this.state = {
            hideTabs: false,
            tabIndex: this.contextService.get('tabIdxDateneingabeBetrieblicheDaten') || (isCfm ? 0 : 1)
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateneingabeBetrieblicheDaten', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const gewerk = getGewerk(this.props.data);
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;
        const konfiguration: any = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        const disabledBwlDaten = true/*!hasGewerke*/;
        const disabledKennzahlen = true/*!hasGewerke*/;
        const disabledMotivation: boolean = !isCfm;
        const disabledStandorte: boolean = !hasGewerke || konfiguration.mehrere_standorte_orig !== 1;
        const disabledVeranstaltungen: boolean = konfiguration.veranstaltungen_orig !== 1;
        const disabledZustaendigkeiten: boolean = !hasGewerke || konfiguration.daten_zustaendigkeiten_orig !== 1;
        const tabRoutings: any[] = [
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_MOTIVATION },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KONFIGURATION },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_ZUSTAENDIGKEITEN },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_BWL_DATEN },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KENNZAHLEN },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_SONSTIGE_DATEN },
            { path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_VERANSTALTUNGEN }
        ];

        return (
            <Tabs
                className='tabs-dateneingabe'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxDateneingabeBetrieblicheDaten', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab disabled={disabledMotivation}>Motivation/Bilanzgrenzen</Tab>
                    <Tab>Konfiguration</Tab>
                    <Tab>{ApiService.bereichKey === 'kommunalverwaltung' ? 'Daten der Verwaltung' : 'Unternehmensdaten'}</Tab>
                    <Tab disabled={disabledStandorte}>{ApiService.bereichKey === 'kommunalverwaltung' ? 'Kategorien' : 'Standorte'}</Tab>
                    <Tab disabled={disabledZustaendigkeiten}>Zuständigkeiten</Tab>
                    <Tab disabled={disabledBwlDaten}>BWL-Daten</Tab>
                    <Tab disabled={disabledKennzahlen}>Eigene Kennzahlen (Definition)</Tab>
                    <Tab disabled>Sonstige Daten</Tab>
                    <Tab disabled={disabledVeranstaltungen}>Veranstaltungen</Tab>
                </TabList>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0 }}
                >
                    {!disabledMotivation && <>
                        {getDefaultHelpIcon('pageMotivation', 'Hilfe zur Motivation', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DateneingabeBetrieblicheDatenMotivation
                            data={this.props.data}
                        />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pageKonfiguration', 'Hilfe zur Konfiguration', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateneingabeBetrieblicheDatenKonfiguration
                        data={this.props.data}
                        gefuehrterModus={this.props.gefuehrterModus}
                        onRoutingChange={this.props.onRoutingChange}
                    />
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 2 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pageUnternehmen', 'Hilfe zu den Unternehmensdaten', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <DateneingabeBetrieblicheDatenUnternehmensdaten
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    {!disabledStandorte &&
                        <DateneingabeBetrieblicheDatenStandortGebaeude
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortSelected={this.props.standortSelected}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    {!disabledZustaendigkeiten &&
                        <DateneingabeBetrieblicheDatenZustaendigkeiten />
                    }
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    {!disabledBwlDaten &&
                        <DateneingabeBetrieblicheDatenBwlDaten
                            standortSelected={this.props.standortSelected}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    {!disabledKennzahlen &&
                        <DateneingabeBetrieblicheDatenKennzahlen
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    <DateneingabeBetrieblicheDatenSonstigeDaten />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}>
                    {!disabledVeranstaltungen &&
                        <DateneingabeBetrieblicheDatenVeranstaltungen
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortSelected={this.props.standortSelected}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }
}
